import ActionButton from '@repo/ui/action-button'
import { FamilyTwoIcon, RelationIcon } from '@repo/ui/icons'
import Modal from '@repo/ui/modal'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { getSimilarParentEnrollments } from '../../../../api/enrollments/get-similar-parents-enrollments'
import { useModalManager } from '../../../../lib/hooks/use-modal-manager'
import { ApplicationStatusEnum } from '../../../../lib/types/enums/enrollment/application-status.enum'
import { EnrollmentDetailsView, filterEnrollmentsByStatus } from '../enrollment-history-view'

type Props = {
  enrollmentId: number
}

const EnrollmentParentsRelatedTripsButton = ({ enrollmentId }: Props) => {
  const { modalState, toggleModal, closeModel } = useModalManager<'parents-related-trips'>([
    'parents-related-trips'
  ])

  const { data: similarParentEnrollments } = useQuery({
    queryKey: ['similar-parent-enrollments', enrollmentId],
    queryFn: () => getSimilarParentEnrollments(enrollmentId)
  })

  const { confirmedSimilarParentEnrollments, enrollingSimilarParentEnrollments } = useMemo(() => {
    const confirmedSimilarParentEnrollments = filterEnrollmentsByStatus(
      ApplicationStatusEnum.CONFIRMED,
      similarParentEnrollments
    )

    const enrollingSimilarParentEnrollments = filterEnrollmentsByStatus(
      ApplicationStatusEnum.TO_BE_CONTACTED,
      similarParentEnrollments
    )

    return {
      confirmedSimilarParentEnrollments,
      enrollingSimilarParentEnrollments
    }
  }, [similarParentEnrollments])

  return (
    <>
      {((confirmedSimilarParentEnrollments && confirmedSimilarParentEnrollments.length > 0) ||
        (enrollingSimilarParentEnrollments && enrollingSimilarParentEnrollments.length > 0)) && (
        <ActionButton
          icon={RelationIcon}
          variant={'lightPurple'}
          onClick={() => toggleModal('parents-related-trips')}
          tooltipText={'Bulletins liés aux parents'}
        />
      )}

      {/* parents related trips modal */}
      <Modal
        size={'medium'}
        icon={FamilyTwoIcon}
        title={'Bulletins liés aux parents'}
        isOpen={modalState['parents-related-trips']}
        onCancel={() => closeModel('parents-related-trips')}
      >
        <EnrollmentDetailsView
          mode={'user'}
          sections={[
            { title: 'Liste des bulletins liés', data: confirmedSimilarParentEnrollments },
            { title: 'Liste des bulletins en cours', data: enrollingSimilarParentEnrollments }
          ]}
        />
      </Modal>
    </>
  )
}

export default EnrollmentParentsRelatedTripsButton
